var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('cTable',{ref:"table",attrs:{"fields":_vm.fields,"header":_vm.header,"methods":_vm.methods,"modals":_vm.modals,"config":_vm.config},scopedSlots:_vm._u([{key:"ROLEAUTH",fn:function(ref){
var visible = ref.visible;
var params = ref.params;
return [(visible)?_c('Auth',{ref:"childTree",attrs:{"row":params}}):_vm._e()]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }